var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.669.818h7.634l-.901 4.438c2.332-3.649 5.003-4.7 8.274-4.926 1.128-.036 2.52.113 3.762.301l-1.469 5.83c-1.202-.301-2.48-.527-3.609-.527-4.513-.075-7.861 2.97-9.027 7.331L76.7 23.271h-7.897c1.954-7.484 4.55-15.644 5.866-22.453z",
    fill: "#B9B9B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.962 10.79c1.316-.638 5.905-.569 8.876-.945 3.423-.414 8.198-2.294 8.084-5.153-.187-3.046-2.894-3.737-5.414-3.398-5.942.865-9.816 4.758-11.546 9.497zm-.736 1.945c-.15 1.315-.316 2.714-.204 3.768.488 3.723 3.753 5.464 7.25 5.577 2.913.069 6.464-1.673 8.396-3.844.365-.41.784-.276 1.031.051.189.25.115.815-.06.987-3.032 3.012-6.151 4.711-10.486 4.748-4.927.038-11.097-1.84-11.848-6.955-.113-.602-.113-1.279-.038-1.994C47.245 5.598 55.897.48 64.396.029c4.061-.226 9.93.827 9.59 5.228-.338 4.626-7.334 6.243-11.885 6.356-3.836.113-8.558.096-9.874 1.122z",
    fill: "#B9B9B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.983 18.083l-1.278 4.889c-2.144.452-4.929.866-7.486.79-7.598-.15-13.164-3.649-12.825-10.87C26.807 4.58 35.044.33 42.98.217c2.633 0 5.04.263 7.71.903l-2.37 4.7c-1.73-.488-4.062-.94-6.394-.714-3.649.263-6.996 2.22-7.974 6.056-1.279 4.813 1.505 8.2 6.432 8.2 2.595 0 5.116-.526 7.598-1.279z",
    fill: "#B9B9B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.863.292c6.356 0 11.143 1.46 11.6 6.738.176 2.03-.564 3.84-1.128 5.985l-2.65 10.296c-5.077 0-9.214.112-13.802.489-4.25 0-9.328-.903-9.328-6.32.089-8.85 13.803-8.049 19.633-8.049 1.241-3.535-1.655-4.964-5.717-4.964-3.686 0-6.722 1.053-9.693 2.031L5.82 1.721C8.717.781 12.44.292 15.863.292zm3.46 12.675c-3.203 0-12.253-.756-12.253 4.137 0 2.445 2.557 2.81 4.701 2.81 5.634 0 6.513-1.968 7.552-6.947z",
    fill: "#B9B9B9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcer);
export default __webpack_public_path__ + "static/media/acer.1a1d9ca9ef78190dfe753b3010d9ddd4.svg";
export { ForwardRef as ReactComponent };